import type { TokenVerifyResult } from '@volley/crucible-ipc-types/ipc-channels';

export const INCOMPLETE_TOKEN_VERIFY_MESSAGE =
  'Foundry returned an incomplete verification result. Try again.';

/**
 * Narrows a runtime tokens:verify payload to the complete wire contract.
 *
 * The typed IPC bridge promises all five sections, but version skew can
 * deliver an older partial payload. Consumers must check completeness before
 * dereferencing a credential or system-tool section.
 */
export function isCompleteTokenVerifyResult(
  result: Partial<TokenVerifyResult> | null | undefined,
): result is TokenVerifyResult {
  return Boolean(result?.github && result.anthropic && result.git && result.node && result.pnpm);
}
